import {ComponentData} from "../../engine/tools/EntityManager";
import {Vector2} from "../../engine/utils/Vector2";
import {Pointer} from "../../engine/tools/InputManager";
import {Rect} from "../../engine/utils/Rect";

export class MoveGrabState implements ComponentData {
    grabOffset: Vector2
    pointer: Pointer
    grabRadius:number = 120
    rect: Rect
    maxSpeed: number = 999999999999999
    speed: Vector2 = new Vector2()

    constructor(options?: Partial<MoveGrabState>) {
        Object.assign(this, options)
    }
}